import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import filterConstants from '../../views/filter/constants';

const filters = {
  namespaced: true,
  state: {
    savedFilters: {},
    activeFilters: {},
    currentFilter: null,
    isOpen: false,
    isActive: false,
    isNotFound: false,
    isDisable: false,
    advancedSettings: {
      [filterConstants.FILTERS.reportsTimeMonth]: {
        isShowNotificationMessage: false,
      },
      [filterConstants.FILTERS.reportsBudgetMonth]: {
        isShowNotificationMessage: false,
      },
      [filterConstants.FILTERS.reportsProgressMonth]: {
        isShowNotificationMessage: false,
      },
      [filterConstants.FILTERS.reportsTimeProject]: {
        baselineEnabled: false,
        isShowNotificationMessage: false,
      },
      [filterConstants.FILTERS.reportsBudgetProject]: {
        baselineEnabled: false,
        isShowNotificationMessage: false,
      },
      [filterConstants.FILTERS.reportsProgressSchedule]: {
        baselineEnabled: false,
        isShowNotificationMessage: false,
      },
    },
  },
  getters,
  mutations,
  actions,
};

export default filters;
